<template>
  <div class="map-wrap">
    <baidu-map :center="center" :zoom="zoom" map-type="BMAP_NORMAL_MAP" @load="loadMap" @ready="handler" :mapStyle="mapStyleWhite" style="width:100%;height:100%;" ak="FNPat11O65z0oriZtFZkc9hPSKh4rrD2" :scroll-wheel-zoom="true">
      <!-- :position="markerPoint" -->
      <bm-marker v-for="(item,index) in marketDa" :key="index" :position="item.markerPoint" :icon="{url:'../img/location-top.png',size: { width: 40, height: 40 }}" @click="bindMarkerPonit(index,item)">
        <!-- address -->
        <!-- content="黄埔区区政府" -->
        <bm-label v-if="showName" :content="item.name" :labelStyle="{color: '#fff', fontSize : '16px',backgroundColor:'#ff8355',borderRadius: '6px',border:'0px',padding:'4px 10px'}" :offset="{width: 40, height: 0}" />
      </bm-marker>
    </baidu-map>

    <div class="float-box" v-show="showDetails">
      <div class="float-box-item">
        <i class="iconfont icon-bianpeidianzhanshuliang1"></i>
        <div>变配电站数量</div>
        <div>
          <label class="num">{{showData.substation}}</label>个
        </div>
      </div>
      <div class="float-box-item">
        <i class="iconfont icon-bianyaqizongrongliang1"></i>
        <div>变压器总容量</div>
        <div>
          <label class="num">{{showData.transformer}}</label>kVA
        </div>
      </div>
      <div class="float-box-item">
        <i class="iconfont icon-dangqianzonggongshuai1"></i>
        <div>当前总功率</div>
        <div>
          <label class="num">{{showData.powerTotal}}</label>kW
        </div>
      </div>
      <div class="float-box-item">
        <i class="iconfont icon-dangqianzongyongdian"></i>
        <div>当日总用电</div>
        <div>
          <label class="num">{{showData.electricityTotal}}</label>kW·h
        </div>
      </div>
      <div class="float-box-item">
        <i class="iconfont icon-wangguanshuliang1"></i>
        <div>网关数量</div>
        <div>
          <!-- <label class="num">{{showData.gateway}}<label></label>{{(showData.gatewayRed)}}</label>个 -->
          <label class="num">{{showData.gateway}}</label>
          <label class="numR">({{showData.gatewayRed}})</label>个
        </div>
      </div>
      <div class="float-box-item">
        <i class="iconfont icon-yibiaoshuliang1"></i>
        <div>仪表数量</div>
        <div>
          <!-- <label class="num">{{showData.meter}}</label><label>{{(showData.meterRed)}}</label>个 -->
          <label class="num">{{showData.meter}}</label>
          <label class="numR">({{showData.meterRed}})</label>个
        </div>
      </div>
      <div class="float-box-item">
        <i class="iconfont icon-dangrigaojing"></i>
        <div>当日报警</div>
        <div>告警总数</div>
        <div>
          <label class="num">{{showData.alarmTotal}}</label>个
        </div>
      </div>
      <div class="float-box-item">
        <i class="iconfont icon-dangrigaojing"></i>
        <div>当日报警</div>
        <div>未处理数</div>
        <div>
          <label class="numR">{{showData.alarmNotDeal}}</label>个
        </div>
      </div>

      <div class="float-box-btn" @click="bindShowLabel">{{showName?'隐藏':'显示'}}名称</div>
    </div>
  </div>
</template>
<script>
import { BaiduMap, BmMarker, BmLabel } from "vue-baidu-map";
import api from "@common/api/index.js";
export default {
  name: "mapNavigation",
  // 引用组件
  components: { BaiduMap, BmMarker, BmLabel },
  data () {
    return {
      center: { lng: 0, lat: 0 },
      zoom: 18,
      markerPoint: { lng: 113.487155, lat: 23.18747 },
      showDetails: true,
      showName: false,
      showLabelIndex: "",
      isShowLabel: false,
      mapStyleWhite: {
        styleJson: [
          {
            featureType: "land",
            elementType: "geometry",
            stylers: {
              color: "#e7f7fc"
            }
          },
          {
            featureType: "water",
            elementType: "all",
            stylers: {
              color: "#96b5d6"
            }
          },
          {
            featureType: "green",
            elementType: "all",
            stylers: {
              color: "#b0d3dd"
            }
          },
          {
            featureType: "highway",
            elementType: "geometry.fill",
            stylers: {
              color: "#a6cfcf"
            }
          },
          {
            featureType: "highway",
            elementType: "geometry.stroke",
            stylers: {
              color: "#7dabb3"
            }
          },
          {
            featureType: "arterial",
            elementType: "geometry.fill",
            stylers: {
              color: "#e7f7fc"
            }
          },
          {
            featureType: "arterial",
            elementType: "geometry.stroke",
            stylers: {
              color: "#b0d5d4"
            }
          },
          {
            featureType: "local",
            elementType: "labels.text.fill",
            stylers: {
              color: "#7a959a"
            }
          },
          {
            featureType: "local",
            elementType: "labels.text.stroke",
            stylers: {
              color: "#d6e4e5"
            }
          },
          {
            featureType: "arterial",
            elementType: "labels.text.fill",
            stylers: {
              color: "#374a46"
            }
          },
          {
            featureType: "highway",
            elementType: "labels.text.fill",
            stylers: {
              color: "#374a46"
            }
          },
          {
            featureType: "highway",
            elementType: "labels.text.stroke",
            stylers: {
              color: "#e9eeed"
            }
          }
        ]
      },
      mapStyleBlack: {
        styleJson: [
          {
            featureType: "land",
            elementType: "geometry",
            stylers: {
              color: "#212121"
            }
          },
          {
            featureType: "building",
            elementType: "geometry",
            stylers: {
              color: "#2b2b2b"
            }
          },
          {
            featureType: "highway",
            elementType: "all",
            stylers: {
              lightness: -42,
              saturation: -91
            }
          },
          {
            featureType: "arterial",
            elementType: "geometry",
            stylers: {
              lightness: -77,
              saturation: -94
            }
          },
          {
            featureType: "green",
            elementType: "geometry",
            stylers: {
              color: "#1b1b1b"
            }
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: {
              color: "#181818"
            }
          },
          {
            featureType: "subway",
            elementType: "geometry.stroke",
            stylers: {
              color: "#181818"
            }
          },
          {
            featureType: "railway",
            elementType: "geometry",
            stylers: {
              lightness: -52
            }
          },
          {
            featureType: "all",
            elementType: "labels.text.stroke",
            stylers: {
              color: "#313131"
            }
          },
          {
            featureType: "all",
            elementType: "labels.text.fill",
            stylers: {
              color: "#8b8787"
            }
          },
          {
            featureType: "manmade",
            elementType: "geometry",
            stylers: {
              color: "#1b1b1b"
            }
          },
          {
            featureType: "local",
            elementType: "geometry",
            stylers: {
              lightness: -75,
              saturation: -91
            }
          },
          {
            featureType: "subway",
            elementType: "geometry",
            stylers: {
              lightness: -65
            }
          },
          {
            featureType: "railway",
            elementType: "all",
            stylers: {
              lightness: -40
            }
          },
          {
            featureType: "boundary",
            elementType: "geometry",
            stylers: {
              color: "#8b8787",
              weight: "1",
              lightness: -29
            }
          }
        ]
      },
      companyId: 20,
      marketDa: [],
      showData: {},
      showIndex: -1,
      show: -1,
      time: 60,
      interTime: null
    };
  },
  // 在实例初始化之后，数据观测(data observer) 和 event/watcher 事件配置之前被调用。
  beforeCreate () { },
  // 实例已经创建完成之后被调用。
  created () {
    let vm = this;
    vm.getData();
  },
  // el 被新创建的 vm.$el 替换，并挂载到实例上去之后调用该钩子。
  mounted () { },
  // keep-alive组件激活时调用
  activated () { },
  // 数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子
  updated () { },
  //当前路由改变
  beforeRouteUpdate () { },
  // Vue 实例销毁后调用
  destroyed () { },
  // 计算属性
  computed: {},
  // 数据监听
  watch: {},
  // 方法定义
  methods: {
    //获取数据
    getData () {
      let vm = this;
      vm.$api.tmp.getMapNavigation(vm.$store.state.user.currentCompanyId).then(res => {
        if (res.success) {
          res.data.gis.forEach(item => {
            //   addressGisX
            item["markerPoint"] = {
              lng: Number(item.addressGisX),
              lat: Number(item.addressGisY)
            };
          });
          vm.marketDa = res.data.gis;
          vm.showData = res.data;
          if (vm.interTime) {
            clearTimeout(vm.interTime);
          }
          if (vm.time > 0) {
            vm.interTime = setTimeout(() => {
              vm.getData();
            }, vm.time * 1000);
          }
        } else {
          console.log(res)
          vm.$message.error(res.msg)
        }

      });
    },
    loadMap () { },
    handler () {
      this.center.lng = 113.487155;
      this.center.lat = 23.18747;
      this.zoom = 15;
    },
    bindMarkerPonit (index, item) {
      // this.showDetails = true;
      // this.showData = item;
      // this.show = index;
    },
    bindShowLabel () {
      this.showName = !this.showName;
    }
  }
};
</script>
<style lang="scss" scoped>
.map-wrap {
  width: 100%;
  height: 100%;
  position: relative;
}
.float-box {
  position: absolute;
  top: calc(50% - 250px);
  right: 20px;
  border-radius: 10px;
  width: 240px;
  background: #ffffff;
  display: flex;
  box-sizing: border-box;
  flex-wrap: wrap;
  box-shadow: 0px 0px 10px 5px rgba(165, 165, 165, 0.9);
  overflow: hidden;
}
.float-box-item {
  width: 50%;
  color: #000;
  display: flex;
  flex-flow: column;
  padding: 10px;
  box-sizing: border-box;
}
.float-box-item i {
  font-size: 30px;
  // color: rgb(1, 173, 168);
  color: #0097ee;
}
.float-box-item div {
  padding-top: 4px;
}
.float-box-item .num {
  font-size: 16px;
  color: rgb(255, 171, 68);
  padding: 0px 5px;
}
.float-box-item .numR {
  font-size: 16px;
  color: rgb(255, 0, 0);
  padding: 0px 5px;
}
.float-box-btn {
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
  background: #00388c;
  color: #fff;
  cursor: pointer;
}
.float-box-btn:hover {
  background: #022861;
}
</style>